import { defineStore } from 'pinia';

export const useSitemapStore = defineStore('studio-documents-sitemap', () =>
{
    const updated = ref<boolean>(false);

    return { updated };
});
